import executeSearch from '../actions/executeSearch';
import CortanaComposeDataProvider from '../editorDataProvider/CortanaComposeDataProvider';
import CortanaComposePluginTrigger from '../utils/cortanaComposePluginTrigger';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { lazyPickerPluginModule } from 'owa-editor-picker-plugin-module';
import ScrollAdapter from 'owa-scroll-adapter/lib/ScrollAdapter';
import { EditorPickerPluginInterface } from 'roosterjs-plugin-picker/lib/PickerPlugin';

export type LazyCortanaComposePickerPlugin = LazyPlugin<EditorPickerPluginInterface>;
const LazyCortanaComposePickerPluginClass = createLazyPlugin(
    lazyPickerPluginModule,
    m => m.PickerPlugin,
    'CortanaComposePicker',
    CortanaComposePluginTrigger
);

export default function createLazyCortanaPickerPlugin(
    scrollAdapter: ScrollAdapter
): LazyCortanaComposePickerPlugin {
    executeSearch('', ''); // execute a search without context when the plugin is first initialized so the results are cached
    return new LazyCortanaComposePickerPluginClass(new CortanaComposeDataProvider(scrollAdapter), {
        elementIdPrefix: 'OWACC',
        changeSource: 'CortanaCompose',
        triggerCharacter: '/',
    });
}
